import { TrackingResult, TrackingSummaryApiModel } from '~/lib/api/smartsend/types';

interface TrackingSummary {
  summary: TrackingSummaryApiModel;
  trackable: boolean;
  rts: boolean;
  links: { [key: string]: string; LocalCourierTrackingLink?: string; RTS?: string };
}

const ConvertToTrackingSummary = (r: TrackingResult, initial: TrackingSummaryApiModel): TrackingSummary => {
  const output: TrackingSummary = {
    summary: {
      LatestStatus: '',
      DroppedOff: undefined,
      Collected: undefined,
      InTransit: undefined,
      AtDepot: undefined,
      DeliveryScheduled: undefined,
      Delivered: undefined,
      MajorError: undefined,
      LastUpdated: undefined,
      ...initial
    },
    trackable: !!r.Trackable,
    rts: r?.Tags?.includes('RTS'),
    links: r?.Links || {}
  };

  const orderedStatuses: { date: Date; status: string }[] = [];

  // Update model with the statuses from the tracking
  r?.Tracking?.filter((x) => !!x.Stages).forEach((x) => {
    for (const s in x.Stages) {
      if (x.Stages[s]) {
        output.summary[s] = new Date(x.Stages[s]);
        orderedStatuses.push({ status: s, date: output.summary[s] });
      }
    }
  });

  // Update last updated based on tracking
  if (!output.summary.LastUpdated) {
    const latest = orderedStatuses.sort((a, b) => b.date.valueOf() - a.date.valueOf())[0];
    if (latest) {
      output.summary.LatestStatus = latest.status;
      output.summary.LastUpdated = latest.date;
    }
  }

  return output;
};
export default ConvertToTrackingSummary;
